import { render, staticRenderFns } from "./ShippingInformation.vue?vue&type=template&id=6ba63793"
import script from "./ShippingInformation.vue?vue&type=script&lang=js"
export * from "./ShippingInformation.vue?vue&type=script&lang=js"
import style0 from "./ShippingInformation.vue?vue&type=style&index=0&id=6ba63793&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports